import { Component, Input, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { FileInfo, UploadComponent } from "@progress/kendo-angular-upload";


@Component({
  selector: 'multiple-imagen-upload',
  template: `
    <div class="row">    
      <div class="col-xs-12 col-sm-12 example-col">
        <kendo-textbox-container>
          <kendo-upload [multiple]="true" [saveUrl]="uploadSaveUrl" [removeUrl]="uploadRemoveUrl" (success)="onUploadSuccess($event)" (remove)="onRemoveSuccess($event)" [showFileList]="false"></kendo-upload>
        </kendo-textbox-container>
      </div>
      <div class="col-xs-12 col-sm-12 example-col">
        <!-- {{ imagePreviews | json }} -->
        
        <div class="card-list">

          <div *ngFor="let image of imagePreviews; index as i" style="margin: 5px;">

            <kendo-card width="260px" *ngIf="!image.deleted">

              <img  class="img-preview-item" [src]="image.src" alt="image preview"/>          
                      
              <kendo-card-actions>
                <span class="card-count">#{{i+1}}</span>
                <div style="width: 100%">                  
                  <button class="k-button k-flat" (click)="deleteItem(image, i)" style="float: right;">
                    <span class="k-icon k-i-trash"></span>
                  </button>                  
                </div>
                
              </kendo-card-actions>
        
            </kendo-card>


          </div>
        </div>
      </div>
    </div>       
    `,
    styles: [`      
      .k-textbox-container, input.k-textbox {
        width: 100%;
      }
      .img-preview {
        text-align: center;
      }
      .img-preview img {
        // height: 128px;
        // margin: 5px; 
        // border-radius: 50%!important;
      }
      .img-preview-item {
        // width: 150px; 
        // margin: 5px;
      }




      .card-list {
        /* display: flex; */
        display: -webkit-box;
        justify-content: space-evenly;
        flex-wrap: wrap;
      }
      .box .k-button-icon {
        font-size: 16px;
        align-self: center;
      }
      .card-count {
        font-size: 13px;
        align-self: center;
        color: #656565;
      }
      .k-button {
        outline: none;
      }
      .k-button .k-i-heart {
        color: #ff6358;
      }
      .k-card-subtitle .k-icon {
        vertical-align: baseline;
        font-size: 12px;
      }
      .k-card-media li img {
        width: 285px;
      }
      .k-card-action {
        flex: 0 0 auto;
      }
    `],
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        multi:true,
        useExisting: MultipleImagenUploadComponent
      }     
    ]
})
export class MultipleImagenUploadComponent implements ControlValueAccessor {  
  
  //Window
  @ViewChild(UploadComponent, {static: false}) upload !: UploadComponent;  

  //Input: table
  private _folder : string = '__FOLDER__';

  @Input()
  set folder(value: string) {
    this._folder = (value && value.trim());
    // this.defaultImage = `/uploads/${this._folder}/_DEFAULT.png`;
    // console.log('set table = ' + this._table);
  }

  get folder(): string { return this._folder; }

  //Input: defaultImage
  // protected defaultImage: string = '__DEFAULT_IMAGE__';

  protected imagePreviews: any[] = [];

  //Input: value
  protected _value: any[] = [];

  //@Override
  protected onChange = (value) => {};

  //@Override
  protected onTouched = () => {};

  //@Override
  protected touched = false;

  //@Override
  protected disabled = false;

  protected uploadSaveUrl: string = 'saveUrl'; // should represent an actual API endpoint
  
  protected uploadRemoveUrl: string = 'removeUrl'; // should represent an actual API endpoint
  

  //@Override
  public writeValue(value: any[]) {
    // console.log('writeValue', value)
    this._value = value;
    this.imagePreviews = value;
    // this.upload.addFiles(this.myFiles);
  }

  //@Override
  public registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  //@Override
  public registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  //@Override
  protected markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  //@Override
  public setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  //@Override
  // public validate(control: AbstractControl): ValidationErrors | null {
  //   const value = control.value;
  //   // if (value < 0) {
  //     return {
  //       valid: {
  //         value
  //       }
  //     };
  //   // }
  // }

  constructor(protected http: HttpClient) {
    // this._value = this.defaultImage;   
  }

  public valueChange(value: any[]): void {

    this.markAsTouched();
    if (!this.disabled) {
      this._value = value;
      this.onChange(this._value);
    }

  }

  public onUploadSuccess(e: any): void {
    let t = this;
    // console.log(e.operation);
    if(e.operation == 'upload'){
      
      // console.log('onUploadSuccess', e.files[0].name, e);

      console.log('onUploadSuccess', e.files);

      const formData: FormData = new FormData();
      formData.append('folder', t.folder);
      formData.append('image', e.files[0].rawFile, e.files[0].name);
      this.http
        .post(`${environment.apiUrl}/upload`, formData)
        // .map((e) => { file: e.file; })
        .subscribe(
          (res: any) => {
            console.log(`UPLOAD in folder ${this.folder} is successful: `, res);            
            this.imagePreviews.unshift({uid: null, src: res.file, deleted: 0});            
            this.valueChange(this.imagePreviews);
          },
          (fail) => {        
            console.log("Error", fail);
            // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
          }
        );
        // .catch(function(e) { console.log(e); return true; });

    }
    
  };

  // public onRemoveSuccess(e: any): void {
    
  //   console.log(`remove event: ${e.files[0].name}`);

  //   const index = this.imagePreviews.findIndex((item) => item.uid === e.files[0].uid);

  //   if (index >= 0) {        

  //       const file: string = this.imagePreviews[index].src;
  //       console.log('onRemoveSuccess', file);

  //       this.http
  //         .post(`${this.APP_URL}/upload_remove`, { filename: file })
  //         // .map((e) => { file: e.file; })
  //         .subscribe(
  //           (res: any) => {
  //             console.log(`Image ${file} removed from server successful: `, res);
  //             this.imagePreviews.splice(index, 1);
  //             this.valueChange(this.imagePreviews);
  //           },
  //           (fail) => {        
  //             console.log("Error", fail);
  //             // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
  //           }
  //         );

  //   }

  // };

  protected deleteItem(image, index) {

    this.imagePreviews[index].deleted = 1;
    // this.imagePreviews.splice(index, 1);
    this.valueChange(this.imagePreviews);

  }

}
